import style from "../styles/terms.module.scss";
import ContactBanner from "../components/contact-banner";
import ContactForm from "../components/contact-form";
import { BottomSpacer, MidSpacer } from "../components/spacer";

export default function Terms() {

  return (
    <div>
      <div className={style.spacer} />
      <ContactBanner />
      <MidSpacer/>
      <div className={style.container}>
        <h1 className={style.heading}>Terms & Conditions - Teckengineering Ltd</h1>
      <MidSpacer/>
        <p>
          <i>Last updated: Tuesday 6th January 2026</i>
        </p>
        <p>These Terms & Conditions (“Terms”) apply to all electrical services provided by Teckengineering LTD (“we”, “us”, “our”), a company based in London, United Kingdom. By booking or using our services, you (“you”, “the customer”, “client”) agree to these Terms.</p>
          <h2>1. Services Provided</h2>
        <p>Teckengineering LTD provides domestic and commercial electrical services, including but not limited to:</p>
        <ol>
          <li>Electrical wiring and rewiring</li>
          <li>Electrical Installation Condition Reports (EICR)</li>
          <li>Portable Appliance Testing (PAT)</li>
          <li>Fire alarm testing</li>
          <li>Emergency lighting testing</li>
          <li>General electrical fault finding and repairs</li>
        </ol>
        <h2>2. Eligibility</h2>
        <p>Our services are available to all customers, including private homeowners, tenants, landlords, estate agents, commercial clients, and businesses.</p>
        <h2>3. Booking & Appointments</h2>
    
        <p>3.1 You can book services through our website, by phone, or via email.</p>
        <p>3.2 Appointment times are approximate and may vary due to traffic, job duration, or unforeseen circumstances.</p>
        <p>3.3 You must ensure safe and reasonable access to the premises at the agreed appointment time.</p>
        <h2>4. Power Isolation During Inspections</h2>
        <p>4.1 Many of our services (including EICRs) require temporarily turning off the power.</p>
        <p>4.2 By booking an inspection service, you agree and consent to us isolating electrical circuits as required.</p>
        <p>4.3 We are not responsible for any issues that occur as a result of turning off the power, including failures of appliances, equipment, or systems that may already be faulty or at end of life.</p>
        <h2>5. Pricing & Payment</h2>
        <p> 5.1 Prices are provided at the time of booking or upon quotation.</p>
        <p> 5.2 Payment must be made in full upon completion of work unless otherwise agreed in writing.</p>
        <p>  5.3 Additional work not included in the original quotation will be charged separately and must be approved by the customer before proceeding.</p>
        <h2>6. Refund & Cancellation Policy</h2>
        <p>6.1 Refunds are available only if the appointment is cancelled at least 24 hours before the scheduled time.</p>
        <p>6.2 Refunds will be processed within 5-10 working days.</p>
        <p> 6.3 Cancellations made within 24 hours of the appointment are not refundable.</p>
        <p> 6.4 If our engineer attends the property but cannot gain access, the full call-out or inspection fee may still be charged.</p>
        <h2>7. Warranty</h2>
        <p>7.1 All work completed by Teckengineering LTD comes with a 24-hour workmanship warranty.</p>
        <p> 7.2 The warranty covers only defects directly caused by our work.</p>
        <p>  7.3 The warranty does not cover:</p>
        <ol>
          <li>Pre-existing electrical faults</li>
          <li>Damage caused by misuse or third-party work</li>
          <li>Faults due to old, unsafe, or deteriorated wiring or equipment</li>
        </ol>
        <h2> 8. Inspection Reports (EICR, PAT, etc.)</h2>
        <p> 8.1 Inspection reports reflect the condition of the electrical installation at the time of testing only.</p>
        <p>8.2 An unsatisfactory EICR may require remedial work, which is charged separately.</p>
        <p> 8.3 We are not liable for issues arising from hidden defects or inaccessible areas.</p>
        <h2>9. Liability</h2>
        <p>9.1 To the maximum extent permitted by UK law, Teckengineering LTD is not responsible for:</p>
        <ol>
          <li> Loss or damage caused by electrical systems that are already faulty</li>
          <li>Loss of power supply required for testing procedures</li>
          <li>Damage to equipment that fails after power is switched off and back on</li>
          <li>Indirect or consequential losses (e.g., spoiled food, business interruption)</li>
        </ol>
        <p> 9.2 Nothing in these Terms excludes liability where it cannot be legally excluded.</p>
        <h2> 10. Customer Responsibilities</h2>
        <p>You agree to:</p>
        <ol>
          <li>Provide accurate information about the property and electrical installation</li>
          <li>Ensure safe access to all areas that require inspection or work</li>
          <li>Obtain any permissions necessary (e.g., landlord consent)</li>
        </ol>
        <h2>11. Website Use</h2>
        <p>Use of our website (https://teckengineers.co.uk/) is subject to standard website terms including no misuse, no unauthorised copying, and no interference with site functionality.</p>
        <h2> 12. Complaints</h2>
        <p>You may submit complaints to us directly, and we will make reasonable efforts to resolve them promptly.</p>
        <h2>13. Governing Law</h2>
        <p>These Terms are governed by the laws of England and Wales. Any disputes will be handled exclusively by the courts of England and Wales.</p>
        <h2>14. Amendments</h2>
        <p>We may update these Terms at any time. The latest version will always appear on our website.</p>

      </div>
      <MidSpacer />
      <MidSpacer />
      <ContactForm />
      <BottomSpacer />
    </div>
  );
}
